module.exports = __webpack_public_path__ + "img/ElfFemale_Spearwoman.afd59028.png";